(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/prescript.js');
svs = svs || {};
svs.marketplace = svs.marketplace || {};
svs.marketplace.data = svs.marketplace.data || {};
svs.marketplace.data.heroData = svs.marketplace.data.heroData || {};



 })(window);